if (!customElements.get('slideshow-width-scrolling')) {
  customElements.define(
    'slideshow-width-scrolling',
    class SlideshowWidthScrolling extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.slideshow-width-scrolling__content',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.items = parseInt(this.dataset.items) || 1;
        this.tabletItems = parseInt(this.dataset.tabletItems) || 1;
        this.paginationType = this.dataset.paginationType || 'progressbar';
        this.navigationPosition = this.dataset.navigationPosition || 'bottom';
        this.infiniteLoop = this.dataset.infiniteLoop === 'true';

        this.sliderInstance = false;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        // 移动端和桌面端都初始化 slider
        this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        
        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          allowTouchMove: true,
          grabCursor: true,
          navigation: {
            nextEl: this.parentElement.querySelector(this.selectors.nextEl),
            prevEl: this.parentElement.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.parentElement.querySelector(this.selectors.pagination),
            type: this.paginationType,
            clickable: true,
          },
          breakpoints: {
            300:{
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: this.tabletItems,
              spaceBetween: 10,
            },
            1280: {
              slidesPerView: this.items,
              spaceBetween: 20,
            },
          },
          loop: this.infiniteLoop,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();

        this.calcNavButtonsPosition();
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calcNavButtonsPosition() {
        if (this.navigationPosition !== 'middle') return;

        const firstSlide = this.querySelector('.slideshow-width-scrolling__slide');
        const controls = this.parentElement.querySelector('.swiper-controls');
        if (controls && firstSlide && firstSlide.clientHeight > 0) {
          controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstSlide.clientHeight) / 2 + 'px');
        }
      }
    }
  );
}